import { AxiosRequestConfig } from 'axios';
import {
  CompanyRequestProps,
  DeactivateContractData,
  GetChildCompaniesData,
  GetContractsPaginationListData,
  GetContractsFiltersData,
  UpdateCompanyData,
  UpdateControlPauseInfoProps,
  CompaniesByTypesProps,
  UpdateLeaseCombinationsData,
  FilterDataParams
} from './company.types';

class CompanyRequestConfig {
  getDriverReport = ({ pagination, searchParam, sortParam }: CompanyRequestProps): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/driverReport',
    responseType: 'blob',
    data: {
      pagination,
      searchParam,
      sortParam
    }
  });

  updateCompany = (data: UpdateCompanyData): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/update',
    data: {
      updateAccount: data
    }
  });

  getChildCompanies = (data: GetChildCompaniesData): AxiosRequestConfig => ({
    method: 'post',
    url: 'company/GetChildCompanies',
    data
  });

  getAllCompany = (accountId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/getAllCompany',
    data: {
      accountId
    }
  });

  companiesByTypes = (data: CompaniesByTypesProps): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/companiesbytypes',
    data
  });

  getCarDealerships = (columns: string[]): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/getAutohausen',
    data: { columns }
  });

  getParentCompanyContactList = (): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/getParentCompanyContactList',
    data: {}
  });

  costCenterList: AxiosRequestConfig = {
    method: 'get',
    url: 'company/kostenstellelist'
  };

  updateControlPauseInfo = (props: UpdateControlPauseInfoProps): AxiosRequestConfig => {
    const { id, ...attributes } = props;
    return {
      method: 'post',
      url: 'company/UpdateSteueungpauseInfo',
      data: { steueungpauseInfo: { entityName: 'account', id, attributes } }
    };
  };

  getContractsPaginationList = (data: GetContractsPaginationListData): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/CompanyRahmenvertrage',
    data
  });

  getContractsFilters = (data: GetContractsFiltersData = {}): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/CompanyRahmenvertrageFilters',
    data
  });

  deactivateContract = (data: DeactivateContractData): AxiosRequestConfig => ({
    method: 'PATCH',
    url: 'company/RahmenvertrageDeactivate',
    data
  });

  getLeaseCombinations = (accountId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/getLeaseCombinations',
    data: {
      accountId
    }
  });

  updateLeaseCombinations = (data: UpdateLeaseCombinationsData): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/updateLeaseCombinations',
    data
  });

  getExternalAccountInfo = (accountId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/getExternalAccountInfo',
    data: { accountId }
  });

  getTopAccountInfo = (accountId: string): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/getTopAccountInfo',
    data: { accountId }
  });

  driverFilterData = (data: FilterDataParams): AxiosRequestConfig => ({
    method: 'POST',
    url: 'company/driverFilterData',
    data
  });
}

export const companyRequestConfig = new CompanyRequestConfig();
